import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activitiesApi } from '../api';
import type { Activity, ActivityMutationResponse } from '../api/types';
import { useObjectActivities, objectActivitiesQueryKey } from './useObjectActivities';

// Hook to fetch comments for an object
export function useComments(objectId, objectType) {
  const $ = _c(7);
  const {
    data: t0,
    isLoading
  } = useObjectActivities(objectId, objectType);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const activities = t1;
  let t2;
  if ($[2] !== activities) {
    t2 = activities.filter(_temp);
    $[2] = activities;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const comments = t2;
  let t3;
  if ($[4] !== comments || $[5] !== isLoading) {
    t3 = {
      data: comments,
      isLoading
    };
    $[4] = comments;
    $[5] = isLoading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

// Hook to create a comment
function _temp(activity) {
  return activity.type === "comment";
}
export function useCreateComment() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp2,
      onSuccess: (response_0, variables) => {
        const queryKey = objectActivitiesQueryKey(variables.objectId, variables.objectType);
        queryClient.setQueryData(queryKey, t1 => {
          const old = t1 === undefined ? [] : t1;
          return [...old, response_0.activity];
        });
        if (response_0.engagement) {
          queryClient.setQueryData(["activities", "engagement", variables.objectType, variables.objectId], response_0.engagement);
        }
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}

// Hook to delete a comment
async function _temp2(data) {
  const response = await activitiesApi.createComment({
    ...data,
    includeEngagement: true
  });
  if ("activity" in response) {
    return response as ActivityMutationResponse;
  }
  return {
    activity: response as Activity
  };
}
export function useDeleteComment() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp3,
      onSuccess: data_0 => {
        const queryKey = objectActivitiesQueryKey(data_0.objectId, data_0.objectType);
        queryClient.setQueryData(queryKey, t1 => {
          const old = t1 === undefined ? [] : t1;
          return old.filter(activity => activity.id !== data_0.activityId);
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
async function _temp3(data) {
  await activitiesApi.deleteComment(data.activityId);
  return data;
}